import React from 'react'
import { Chart } from "react-google-charts";
import { shadeDefault } from '../InsightsColors';
import { addChartAnnotations, mergeChartOptions, replaceTrailingZerosWithNull} from '../insights_functions';

const InsightBarGraphView =(props)=>{
    const {viewData, activeOption, onSelect} = props

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    //console.log("layout response view", viewData.ViewData);

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        const chartType = viewData.ChartConfig?.chartType || "BarChart";
        const defaultChartOptions = {
                    title: "",
                    bars: "vertical", // Required for Material Bar Charts.
                    bar: { groupWidth: "90%" },
                    hAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    // vAxis: { title: viewData.X_AXIS_Title },
                    legend: "none",
                    vAxis: {
                        title: viewData.X_AXIS_Title,
                        format: 'decimal', // You can customize the format as needed
                        viewWindow: {
                          min: 0, // Adjust as needed based on your data
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                    colors: shadeDefault
                };
        const chartOptions = mergeChartOptions(defaultChartOptions, viewData.ChartConfig?.options);

        const rawData = viewData.ViewData[currentOption].ChartData;
        const normalizedChartData = replaceTrailingZerosWithNull(rawData);
        const chartData = addChartAnnotations(normalizedChartData, viewData.ChartConfig?.annotation);

        const chartFormatters = viewData.ChartConfig?.formatters || [];

        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <Chart
                chartType={chartType}
                data={chartData}
                options={chartOptions}
                formatters={chartFormatters}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightBarGraphView
